
import { defineComponent } from 'vue';
import BidAddEditForm from '@/components/forms/BidAddEditForm.vue';

export default defineComponent({
  name: 'CreateBid',
  components: {
    BidAddEditForm
  }
});
